import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { roleConstant } from '../../app.constant';
import { EditJobAssignmentComponent } from '../../components/edit-job-assignment/edit-job-assignment.component';
import { CreateTimesheetComponent } from '../../components/create-timesheet/create-timesheet.component';
import { AuthenticationService } from '../../services/authentication.service';
import { DataSharedService } from '../../services/data-shared.service';
import { JobAssignmentService } from '../../services/job-assignment.service';
import { TimesheetService } from '../../services/timesheet.service';
import { SendEmailComponent } from '../../components/send-email/send-email.component';
import { SuccessModalComponent } from '../success-modal/success-modal.component';
import { SuccessModal } from 'src/app/app.model';
@Component({
  selector: 'app-inactive-assignments',
  templateUrl: './inactive-assignments.component.html',
  styleUrls: ['./inactive-assignments.component.css']
})
export class InactiveAssignmentsComponent implements OnInit {
  allJobAssignments: any = [];
  jobAssignments: any = [];
  user: any;
  ROLES = roleConstant;
  totalCount: number = 0;
  loading: boolean = false;
  assignmentSearch: string = '';
  currentPage: number = 1;
  pageLimit: number = 20;
  private searchTerms = new Subject<string>();
  constructor(private route: ActivatedRoute,
    private jobAssignmentService: JobAssignmentService,
    private timesheetService: TimesheetService,
    private authService: AuthenticationService,
    public dialog: MatDialog,
    private modalService: NgbModal,
    public dataSharedService: DataSharedService,
    private activeModalService: NgbActiveModal,
    private router: Router,) { }

  ngOnInit(): void {
    this.user = this.authService.userValue;
    this.searchTerms.pipe(debounceTime(400), distinctUntilChanged()).subscribe(() => {
      this.currentPage = 1;
      this.getJobAssignments(1);
    });
    this.route.queryParams.subscribe((params: any) => {
      this.assignmentSearch = params?.name ?? '';
      this.currentPage = 1;
      this.getJobAssignments(1);
    });
  }

  searchAssignment() {
    this.searchTerms.next(this.assignmentSearch);
  }

  getJobAssignments(page: any) {
    this.loading = true;
    this.jobAssignments = [];
    this.allJobAssignments = [];
    let filters =  {
      active : 0,
    }
    this.jobAssignmentService.getJobAssignments(page, filters, this.assignmentSearch).subscribe((jobassignments) => {
      this.jobAssignments = jobassignments.data;
      this.totalCount = jobassignments.meta.total;
      this.loading = false;
      this.allJobAssignments = this.jobAssignments.slice();
    });
  }
  sortData(sort: Sort) {
    const data = this.jobAssignments.slice();
    if (!sort.active || sort.direction === '') {
      this.allJobAssignments = data;
      return;
    }

    this.allJobAssignments = data.sort((a: any, b: any) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'job':
          return compare(a.job, b.job, isAsc);
        case 'candidate':
          return compare(a.candidate, b.candidate, isAsc);
        case 'client':
          return compare(a.client, b.client, isAsc);
        case 'start_date':
          return compare(a.start_date, b.start_date, isAsc);
        case 'end_date':
          return compare(a.end_date, b.end_date, isAsc);
        case 'created_at':
          return compare(a.created_at, b.created_at, isAsc);
        default:
          return 0;
      }
    });
  }

  onStepChange(event: any) {
    this.currentPage = event;
    this.getJobAssignments(event);
  }

  get pageStart(): number {
    return this.totalCount === 0 ? 0 : (this.currentPage - 1) * this.pageLimit + 1;
  }

  get pageEnd(): number {
    return Math.min(this.currentPage * this.pageLimit, this.totalCount);
  }

  openSendMessagePopUp(candidateUuid: any) {
    const modalRef = this.modalService.open(SendEmailComponent, {
      size: 'md',
      backdrop: false,
      modalDialogClass: 'add-reminder-modal'
    });

    modalRef.componentInstance.userUuid = candidateUuid;

    modalRef.result.then((data: any) => {
      if (data?.refresh === true) {
        // this.ngOnInit();
      }
    });
  }

  activateAssignment(assigmentUuid: string) {
    this.jobAssignmentService.activateAssignment(assigmentUuid).subscribe({
      next: (response) => {
          this.activeModalService.close({
            data: true,
          });
          this.successModal('Activated Successfully.');
          this.router.navigate(['assignments/active-assignments'])
      },
      error: (err) => {
      }
    });
  }

  successModal(message: string) {
    const modalRef = this.modalService.open(SuccessModalComponent, {
      size: 'sm',
      modalDialogClass: 'success-modal',
      backdrop: false,
    });
    let data: SuccessModal = {
      message: message,
      image: 'assets/img/checkmark.png',
      duration: 2000,
    }
    modalRef.componentInstance.data = data;
    modalRef.result.then((data) => {
      if (data?.action === 'yes') {
        this.activeModalService.close();
      }
    });
  }

}
function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}